import { AuthLayout } from '@/components/auth/auth-layout';
import { RegisterForm } from '@/components/auth/register-form';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';
import { register } from '@/lib/auth';
import type { UserRole } from '@/lib/types';

export function RegisterPage() {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleRegister = async (data: {
    email: string;
    password: string;
    name: string;
    role: UserRole;
  }) => {
    try {
      await register(data);
      
      toast({
        title: 'Registration successful!',
        description: 'Please check your email to verify your account.',
      });
      navigate('/login');
    } catch (error) {
      toast({
        variant: 'destructive',
        title: 'Error',
        description: error instanceof Error ? error.message : 'Failed to create account',
      });
    }
  };

  return (
    <AuthLayout>
      <RegisterForm
        onRegister={handleRegister}
        onLogin={() => navigate('/login')}
      />
    </AuthLayout>
  );
}